import React, { useState } from "react";
import { Badge, Table } from "react-bootstrap";
import { formatDate } from "../../../../utils/utils";
import NumberFormat from "react-number-format";
import Illustration from "../../../../partials/content/Illustration";

function SalesReturnInvoices({ invoicesImp = [] }) {
  const [invoices, setInvoices] = useState(invoicesImp);
  return (
    <React.Fragment>
      <Table striped borderless size="sm" responsive="xl">
        {invoices && invoices.length > 0 ? (
          <thead>
            <tr>
              <th>A / P Invoice ID</th>
              <th>Invoice Date</th>
              <th>Payment Status</th>
              <th>Grand Total</th>
            </tr>
          </thead>
        ) : null}
        <tbody>
          {invoices && invoices.length > 0 ? (
            invoices.map((item, index) => (
              <tr key={index} className="border-top">
                <td>{item.ID}</td>
                <td>{formatDate(item.invoiceDate)}</td>
                <td>
                  {item.paymentStatus === 1 ? (
                    <Badge variant="danger">{item.paymentStatusDesc}</Badge>
                  ) : item.paymentStatus === 2 ? (
                    <Badge variant="warning">{item.paymentStatusDesc}</Badge>
                  ) : item.paymentStatus === 3 ? (
                    <Badge variant="success">{item.paymentStatusDesc}</Badge>
                  ) : (
                    <Badge variant="dark">{item.paymentStatusDesc}</Badge>
                  )}
                </td>
                <td>
                  <NumberFormat
                    value={item.grandTotal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {item.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td className="text-center py-3" colSpan="6">
                <Illustration
                  imageSource="INVIFO Procurement.png"
                  guidance="No Invoices found"
                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                  size="sm"
                ></Illustration>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </React.Fragment>
  );
}

export default SalesReturnInvoices;
